export default __webpack_public_path__ + "resources/icons/n500-b4d8.webp";